import "./CareAndPruning.module.css";
import Header from "@/reusable_sections/Header";
import BundleBenefits from "./sections/BundleBenefits";
import CommonInquiries from "./sections/CommonInquiries";
import BasDePageOsteomed from "@/reusable_sections/Footer";
import OurSignatureCreations from "./sections/OurSignatureCreations";
import PublicSectorExcellence from "./sections/PublicSectorExcellence";
export default function CareAndPruningPage() {
  return <div>
      <Header />
      <PublicSectorExcellence />
      <BundleBenefits />
      <OurSignatureCreations />
      <CommonInquiries />
      <BasDePageOsteomed />
    </div>;
}